import  {useState}  from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Nav from 'react-bootstrap/Nav';
import Show from './show';

const About = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
    <Nav.Link href="" onClick={handleShow}>About</Nav.Link>
     
      <Offcanvas bg="dark" data-bs-theme="dark" show={show} onHide={handleClose}>
        <Offcanvas.Header
          closeButton
          >
          <Offcanvas.Title>About</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className='dark bg-red' >

    Author: Sushant Naik
  
<br/>
Follow me :
<br/>
<Show/>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default About;